import React from 'react';
import { Skeleton } from '@mui/material';
import pagesStandardStyles from '../../../../pages/Pages.module.css';

interface PerfProductSyncSkeletonDataGridProps {
  /**
   * Whether to show peer group columns
   * @default true
   */
  showPeerGroupColumns?: boolean;
}

/**
 * PerfProductSyncSkeletonDataGrid Component - Displays loading skeleton for Product Sync DataGrid
 * Matches the exact structure of the Product Sync grid with 1 data row and dynamic columns based on peer group toggle
 */
const PerfProductSyncSkeletonDataGrid: React.FC<PerfProductSyncSkeletonDataGridProps> = ({
  showPeerGroupColumns = true,
}) => {
  // Calculate number of columns based on peer group toggle
  // Base columns (5): Participating, Sales (YTD), Units Sold (YTD), CrossLink Matches Made, CrossLink Matches Waiting
  // Additional peer group columns (6): Peer Group Rank + 80% Benchmark for Sales and Units Sold, Peer Group Rank only for both CrossLink columns
  const columnCount = showPeerGroupColumns ? 11 : 5;

  return (
    <div
      className={pagesStandardStyles.dataGrid}
      style={{ width: '100%' }}>
      {/* Header row skeleton */}
      <div style={{ display: 'flex', width: '100%', marginBottom: '1px' }}>
        {Array.from({ length: columnCount }).map((_, index) => (
          <Skeleton
            key={`header-${index}`}
            variant="rectangular"
            height={52}
            sx={{
              flex: 1,
              minWidth: 115.2,
              marginRight: index < columnCount - 1 ? '1px' : 0,
              backgroundColor: '#eeeeee',
              borderRight: '1px solid #c9c9c9',
              borderBottom: '1px solid #c9c9c9',
              ...(index === 0 && { borderLeft: '1px solid #c9c9c9' }),
            }}
          />
        ))}
      </div>

      {/* Single data row skeleton */}
      <div style={{ display: 'flex', width: '100%' }}>
        {Array.from({ length: columnCount }).map((_, index) => (
          <Skeleton
            key={`row-${index}`}
            variant="rectangular"
            height={52}
            sx={{
              flex: 1,
              minWidth: 115.2,
              marginRight: index < columnCount - 1 ? '1px' : 0,
              backgroundColor: '#fff',
              borderRight: '1px solid #c9c9c9',
              ...(index === 0 && { borderLeft: '1px solid #c9c9c9' }),
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default PerfProductSyncSkeletonDataGrid;
